var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "fixed-tabs" },
        [
          _c(
            "van-tabs",
            {
              attrs: { sticky: "", color: "#FFDA3E" },
              on: { click: _vm.handleTabClick },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c("van-tab", { attrs: { name: "", title: "全部" } }),
              _c("van-tab", { attrs: { name: 0, title: "未开始" } }),
              _c("van-tab", { attrs: { name: 1, title: "进行中" } }),
              _c("van-tab", { attrs: { name: 2, title: "已完成" } }),
            ],
            1
          ),
          _c("van-search", {
            staticClass: "fixed width-99 z-99",
            attrs: {
              clearable: "",
              shape: "round",
              "show-action": "",
              placeholder: "输入任务名称搜索",
            },
            on: { search: _vm.onSearch },
            scopedSlots: _vm._u([
              {
                key: "action",
                fn: function () {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-110 h-52 l-h-52 bg-FFDA3E b-r-28 text-center",
                        on: { click: _vm.onSearch },
                      },
                      [_vm._v("搜索")]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.queryData.taskName,
              callback: function ($$v) {
                _vm.$set(_vm.queryData, "taskName", $$v)
              },
              expression: "queryData.taskName",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "h-200" }),
      _c(
        "van-pull-refresh",
        {
          on: { refresh: _vm.onRefresh },
          model: {
            value: _vm.refreshLoading,
            callback: function ($$v) {
              _vm.refreshLoading = $$v
            },
            expression: "refreshLoading",
          },
        },
        [
          _c(
            "van-list",
            {
              attrs: {
                finished: _vm.pageFinished,
                "finished-text": " - 没有更多了 - ",
              },
              on: { load: _vm.onLoad },
              model: {
                value: _vm.pageLoading,
                callback: function ($$v) {
                  _vm.pageLoading = $$v
                },
                expression: "pageLoading",
              },
            },
            _vm._l(_vm.filteredTasks, function (item) {
              return _c(
                "van-row",
                {
                  key: item.id,
                  staticClass: "m-t-10",
                  attrs: { align: "center" },
                },
                [
                  _c("van-col", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      { staticClass: "task-block" },
                      [
                        item.status == 0
                          ? _c(
                              "van-tag",
                              {
                                staticClass: "task-state wks",
                                attrs: {
                                  size: "small",
                                  mark: "",
                                  type: "primary",
                                },
                              },
                              [_vm._v("未开始")]
                            )
                          : _vm._e(),
                        item.status == 2
                          ? _c(
                              "van-tag",
                              {
                                staticClass: "task-state ywc",
                                attrs: {
                                  size: "small",
                                  mark: "",
                                  type: "primary",
                                },
                              },
                              [_vm._v("已完成")]
                            )
                          : _vm._e(),
                        item.status == 1
                          ? _c(
                              "van-tag",
                              {
                                staticClass: "task-state jxz",
                                attrs: {
                                  size: "small",
                                  mark: "",
                                  type: "primary",
                                },
                              },
                              [_vm._v("进行中")]
                            )
                          : _vm._e(),
                        item.status == 3
                          ? _c(
                              "van-tag",
                              {
                                staticClass: "task-state yzz",
                                attrs: {
                                  size: "small",
                                  mark: "",
                                  type: "primary",
                                },
                              },
                              [_vm._v("已中止")]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.viewFeedback(item)
                              },
                            },
                          },
                          [
                            _c(
                              "van-row",
                              {
                                staticClass: "p-t-15",
                                attrs: {
                                  type: "flex",
                                  align: "center",
                                  justify: "center",
                                },
                              },
                              [
                                _c(
                                  "van-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c("van-icon", {
                                      attrs: {
                                        name: "card",
                                        size: "30",
                                        color: "#FFDA3E",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("van-col", { attrs: { span: 19 } }, [
                                  _c("div", { staticClass: "sender-info" }, [
                                    _c("span", { staticClass: "task-title" }, [
                                      _vm._v(_vm._s(item.taskName)),
                                    ]),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "van-row",
                              {
                                attrs: {
                                  type: "flex",
                                  align: "center",
                                  justify: "center",
                                },
                              },
                              [
                                _c("van-col", { attrs: { span: 6 } }, [
                                  _c("div", { staticClass: "sender-info" }, [
                                    _c("span", { staticClass: "row-name" }, [
                                      _vm._v("所属项目"),
                                    ]),
                                  ]),
                                ]),
                                _c("van-col", { attrs: { span: 16 } }, [
                                  _c("div", { staticClass: "sender-info" }, [
                                    _c("span", { staticClass: "row-value" }, [
                                      _vm._v(_vm._s(item.projectName)),
                                    ]),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "van-row",
                              {
                                attrs: {
                                  type: "flex",
                                  align: "center",
                                  justify: "center",
                                },
                              },
                              [
                                _c("van-col", { attrs: { span: 6 } }, [
                                  _c("div", { staticClass: "sender-info" }, [
                                    _c("span", { staticClass: "row-name" }, [
                                      _vm._v("计划时间"),
                                    ]),
                                  ]),
                                ]),
                                _c("van-col", { attrs: { span: 16 } }, [
                                  _c("div", { staticClass: "sender-info" }, [
                                    _c("span", { staticClass: "row-value" }, [
                                      _vm._v(
                                        _vm._s(item.planStartTime) +
                                          "至" +
                                          _vm._s(item.planEndTime)
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "van-row",
                              {
                                attrs: {
                                  type: "flex",
                                  align: "center",
                                  justify: "center",
                                },
                              },
                              [
                                _c("van-col", { attrs: { span: 6 } }, [
                                  _c("div", { staticClass: "sender-info" }, [
                                    _c("span", { staticClass: "row-name" }, [
                                      _vm._v("实际时间"),
                                    ]),
                                  ]),
                                ]),
                                _c("van-col", { attrs: { span: 16 } }, [
                                  _c("div", { staticClass: "sender-info" }, [
                                    _c("span", { staticClass: "row-value" }, [
                                      _vm._v(
                                        _vm._s(
                                          item.startTime == null
                                            ? ""
                                            : item.startTime
                                        ) +
                                          _vm._s(
                                            item.endTime == null
                                              ? ""
                                              : "至" + item.endTime
                                          )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            item.status != 2
                              ? _c(
                                  "van-row",
                                  {
                                    attrs: {
                                      type: "flex",
                                      align: "center",
                                      justify: "center",
                                    },
                                  },
                                  [
                                    _c("van-col", { attrs: { span: 6 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "sender-info" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "row-name" },
                                            [_vm._v("今日是否反馈")]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("van-col", { attrs: { span: 16 } }, [
                                      _c(
                                        "div",
                                        { staticClass: "sender-info" },
                                        [
                                          item.feedBackToday == "已反馈"
                                            ? _c(
                                                "van-tag",
                                                {
                                                  attrs: {
                                                    plain: "",
                                                    type: "primary",
                                                  },
                                                },
                                                [_vm._v("已反馈")]
                                              )
                                            : _vm._e(),
                                          item.feedBackToday == "未反馈"
                                            ? _c(
                                                "van-tag",
                                                {
                                                  attrs: {
                                                    plain: "",
                                                    type: "danger",
                                                  },
                                                },
                                                [_vm._v("未反馈")]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "van-row",
                              {
                                attrs: {
                                  type: "flex",
                                  align: "center",
                                  justify: "center",
                                },
                              },
                              [
                                _c("van-col", { attrs: { span: 6 } }, [
                                  _c("div", { staticClass: "sender-info" }, [
                                    _c("span", { staticClass: "row-name" }, [
                                      _vm._v("任务进度"),
                                    ]),
                                  ]),
                                ]),
                                _c("van-col", { attrs: { span: 16 } }, [
                                  _c(
                                    "div",
                                    { staticClass: "sender-info" },
                                    [
                                      _c("van-progress", {
                                        attrs: {
                                          color: "#FFDA3E",
                                          percentage: item.progress,
                                          "stroke-width": "8",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          {
                            attrs: {
                              type: "flex",
                              align: "center",
                              justify: "center",
                            },
                          },
                          [
                            _c("van-col", { attrs: { span: 10 } }, [
                              _c(
                                "div",
                                { staticClass: "task-btn1" },
                                [
                                  _c(
                                    "van-button",
                                    {
                                      staticClass: "custom-button",
                                      attrs: {
                                        icon: "add-o",
                                        size: "small",
                                        plain: "",
                                        hairline: "",
                                        type: "primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addFeedback(item)
                                        },
                                      },
                                    },
                                    [_vm._v(" 添加反馈 ")]
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _c("van-col", { attrs: { span: 10 } }, [
                              _c(
                                "div",
                                { staticClass: "task-btn2" },
                                [
                                  _c(
                                    "van-button",
                                    {
                                      staticClass: "custom-button",
                                      attrs: {
                                        icon: "browsing-history-o",
                                        size: "small",
                                        plain: "",
                                        hairline: "",
                                        type: "info",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewFeedback(item)
                                        },
                                      },
                                    },
                                    [_vm._v(" 查看详情 ")]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", "lock-scroll": "", round: "" },
          model: {
            value: _vm.addFeedbackShow,
            callback: function ($$v) {
              _vm.addFeedbackShow = $$v
            },
            expression: "addFeedbackShow",
          },
        },
        [
          _c(
            "div",
            { staticClass: "addFeedbackDiv" },
            [
              _c(
                "van-row",
                {
                  staticClass: "feedback-title",
                  on: { click: _vm.closeAddFeedback },
                },
                [
                  _c(
                    "van-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "van-row",
                        { staticClass: "title-row" },
                        [
                          _c(
                            "van-col",
                            { attrs: { align: "center", span: 24 } },
                            [
                              _c("span", { staticClass: "m-r-5" }, [
                                _vm._v("任务反馈"),
                              ]),
                              _c("van-icon", { attrs: { name: "arrow-down" } }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("van-notice-bar", {
                attrs: {
                  "left-icon": "volume-o",
                  text: `提示：当日累计反馈工时上限为 24 小时，当前已提交 ${
                    _vm.receivedHours
                  }
                          小时，剩余最多可反馈 ${
                            24 - Number(_vm.receivedHours)
                          } 小时。`,
                },
              }),
              _c(
                "van-row",
                {
                  staticClass: "feedback-row",
                  attrs: { type: "flex", align: "center", justify: "center" },
                },
                [
                  _c("van-col", { attrs: { span: 6 } }, [
                    _c("div", { staticClass: "sender-info" }, [
                      _c("span", { staticClass: "row-name" }, [
                        _vm._v("任务名称"),
                      ]),
                    ]),
                  ]),
                  _c("van-col", { attrs: { span: 16 } }, [
                    _c("div", { staticClass: "sender-info" }, [
                      _c("span", { staticClass: "row-value" }, [
                        _vm._v(_vm._s(_vm.feedbackForm.taskName)),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "van-row",
                {
                  staticClass: "feedback-row",
                  attrs: { type: "flex", align: "center", justify: "center" },
                },
                [
                  _c("van-col", { attrs: { span: 6 } }, [
                    _c("div", { staticClass: "sender-info" }, [
                      _c("span", { staticClass: "row-name" }, [
                        _vm._v("是否补录"),
                      ]),
                    ]),
                  ]),
                  _c("van-col", { attrs: { span: 16 } }, [
                    _c("div", { staticClass: "sender-info" }, [
                      _c(
                        "span",
                        { staticClass: "row-value" },
                        [
                          _c(
                            "van-radio-group",
                            {
                              attrs: { direction: "horizontal" },
                              on: { change: _vm.blChange },
                              model: {
                                value: _vm.feedbackForm.blFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.feedbackForm, "blFlag", $$v)
                                },
                                expression: "feedbackForm.blFlag",
                              },
                            },
                            [
                              _c(
                                "van-radio",
                                {
                                  attrs: {
                                    "checked-color": "#FFDA3E",
                                    name: "Y",
                                  },
                                },
                                [_vm._v("是")]
                              ),
                              _c(
                                "van-radio",
                                {
                                  attrs: {
                                    "checked-color": "#FFDA3E",
                                    name: "N",
                                  },
                                },
                                [_vm._v("否")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm.feedbackForm.blFlag === "Y"
                ? _c(
                    "van-row",
                    {
                      staticClass: "feedback-row",
                      attrs: {
                        type: "flex",
                        align: "center",
                        justify: "center",
                      },
                    },
                    [
                      _c(
                        "van-col",
                        { attrs: { span: 24 } },
                        [
                          _c("van-field", {
                            attrs: {
                              clickable: "",
                              required: "",
                              readonly: "",
                              label: "补录时间",
                              placeholder: "请选择补录时间",
                            },
                            on: {
                              click: function ($event) {
                                _vm.createTimeShow = true
                              },
                            },
                            model: {
                              value: _vm.feedbackForm.createTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.feedbackForm, "createTime", $$v)
                              },
                              expression: "feedbackForm.createTime",
                            },
                          }),
                          _c(
                            "van-popup",
                            {
                              attrs: { position: "bottom" },
                              model: {
                                value: _vm.createTimeShow,
                                callback: function ($$v) {
                                  _vm.createTimeShow = $$v
                                },
                                expression: "createTimeShow",
                              },
                            },
                            [
                              _c("van-datetime-picker", {
                                attrs: {
                                  type: "datetime",
                                  title: "选择完整时间",
                                  "max-date": _vm.maxDate,
                                },
                                on: {
                                  confirm: _vm.dateTimeConfirm,
                                  cancel: function ($event) {
                                    _vm.createTimeShow = false
                                  },
                                },
                                model: {
                                  value: _vm.feedbackForm.createDateTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.feedbackForm,
                                      "createDateTime",
                                      $$v
                                    )
                                  },
                                  expression: "feedbackForm.createDateTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "van-row",
                {
                  staticClass: "feedback-row",
                  attrs: { type: "flex", align: "center", justify: "center" },
                },
                [
                  _c(
                    "van-col",
                    { attrs: { span: 24 } },
                    [
                      _c("van-field", {
                        attrs: {
                          required: "",
                          rows: "3",
                          autosize: "",
                          label: "完成情况",
                          type: "textarea",
                          maxlength: "500",
                          placeholder: "请输入完成情况",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.feedbackForm.message,
                          callback: function ($$v) {
                            _vm.$set(_vm.feedbackForm, "message", $$v)
                          },
                          expression: "feedbackForm.message",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "van-row",
                {
                  staticClass: "feedback-row",
                  attrs: { type: "flex", align: "center", justify: "center" },
                },
                [
                  _c(
                    "van-col",
                    { attrs: { span: 24 } },
                    [
                      _c("van-field", {
                        attrs: {
                          required: "",
                          type: "number",
                          label: "工时",
                          placeholder: "请输入工时，最多支持一位小数",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "right-icon",
                            fn: function () {
                              return [
                                _c("span", { staticClass: "row-value" }, [
                                  _vm._v(" 小时 "),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.feedbackForm.hour,
                          callback: function ($$v) {
                            _vm.$set(_vm.feedbackForm, "hour", $$v)
                          },
                          expression: "feedbackForm.hour",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.feedbackForm.executorLeader == _vm.loginUser.userId
                ? _c(
                    "van-row",
                    {
                      staticClass: "feedback-row",
                      attrs: {
                        type: "flex",
                        align: "center",
                        justify: "center",
                      },
                    },
                    [
                      _c("van-col", { attrs: { span: 6 } }, [
                        _c("div", { staticClass: "sender-info" }, [
                          _c("span", { staticClass: "row-name" }, [
                            _vm._v("任务进度"),
                          ]),
                        ]),
                      ]),
                      _c("van-col", { attrs: { span: 11 } }, [
                        _c(
                          "div",
                          { staticClass: "sender-info" },
                          [
                            _c("van-slider", {
                              attrs: {
                                "bar-height": "6px",
                                "active-color": "#FFDA3E",
                              },
                              model: {
                                value: _vm.feedbackForm.progress,
                                callback: function ($$v) {
                                  _vm.$set(_vm.feedbackForm, "progress", $$v)
                                },
                                expression: "feedbackForm.progress",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("van-col", { attrs: { align: "right", span: 5 } }, [
                        _c(
                          "div",
                          { staticClass: "sender-info" },
                          [
                            _c("van-field", {
                              attrs: { "input-align": "right", type: "number" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "right-icon",
                                    fn: function () {
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "row-value" },
                                          [_vm._v(" % ")]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                152363567
                              ),
                              model: {
                                value: _vm.feedbackForm.progress,
                                callback: function ($$v) {
                                  _vm.$set(_vm.feedbackForm, "progress", $$v)
                                },
                                expression: "feedbackForm.progress",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "van-row",
                {
                  staticClass: "feedback-row",
                  attrs: { type: "flex", align: "center", justify: "center" },
                },
                [
                  _c(
                    "van-col",
                    { attrs: { span: 24 } },
                    [
                      _c("van-field", {
                        staticClass: "noAfterBorder fileValueBox",
                        attrs: {
                          "input-align": "right",
                          name: "fj",
                          label: "附件",
                          placeholder: "请上传文件",
                        },
                        domProps: { value: _vm.feedbackForm.fileList },
                        scopedSlots: _vm._u([
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("uploadFiles", {
                                  attrs: {
                                    files: _vm.feedbackForm.fileList,
                                    moduleType: "taskFeedback",
                                  },
                                  on: {
                                    success: _vm.uploadSuccess,
                                    fileRemove: (removedFile) =>
                                      _vm.handleFileRemove(
                                        removedFile,
                                        "feedbackForm",
                                        "fileList"
                                      ),
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "van-row",
                {
                  staticClass: "feedback-row",
                  attrs: { type: "flex", align: "center", justify: "center" },
                },
                [
                  _c("van-col", { attrs: { span: 10 } }, [
                    _c(
                      "div",
                      { staticClass: "task-btn1" },
                      [
                        _c(
                          "van-button",
                          {
                            staticClass: "custom-button",
                            attrs: {
                              icon: "revoke",
                              size: "small",
                              plain: "",
                              hairline: "",
                              type: "primary",
                            },
                            on: { click: _vm.closeAddFeedback },
                          },
                          [_vm._v(" 取消 ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("van-col", { attrs: { span: 10 } }, [
                    _c(
                      "div",
                      { staticClass: "task-btn2" },
                      [
                        _c(
                          "van-button",
                          {
                            staticClass: "custom-button",
                            attrs: {
                              icon: "certificate",
                              size: "small",
                              plain: "",
                              hairline: "",
                              type: "info",
                            },
                            on: { click: _vm.submitFeedback },
                          },
                          [_vm._v(" 提交 ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "zjm-fixed-bottom pos-b-20 pos-r-20 bg-FFDB43 cor-FF font-28",
          on: { click: _vm.goBack },
        },
        [_vm._v("返回")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }